import { RESPONSE_CODES } from "@simplyhealth/iam_client_lib";
import {
  sorryUnableTo,
  DEFAULT_PROBLEM_TITLE,
  TRY_AGAIN_LATER_MESSAGE,
  DETAILS_ALREADY_EXIST_MESSAGE,
  CORPORATE_ADMINISTRATOR_ADVICE_MESSAGE,
  ACCOUNT_ALREADY_EXISTS_TITLE,
  TECH_GLITCH_MESSAGE,
  LOGIN_WITH_EXISTING_DETAILS_MESSAGE,
  IF_FORGOTTEN_PASSWORD_MESSAGE,
  ALREADY_CREATED_ACCOUNT_MESSAGE,
  IF_YOU_NEED_HELP_MESSAGE,
  supportCodeMessage
} from "../../../helpers/constants";

export function createUIMessageAndTitleFromResponseCodes(code: string = "", supportCode?: string): [string[], string] {
  const messages = new Array<string>();
  let title = DEFAULT_PROBLEM_TITLE;

  const lowercaseCode = code.toLowerCase();

  switch (lowercaseCode) {
    case RESPONSE_CODES.SignUp_UserNameExists.toLowerCase():
    case RESPONSE_CODES.SignUp_RegistrationError_Account_Exists.toLowerCase():
      title = ACCOUNT_ALREADY_EXISTS_TITLE;
      messages.push(
        ALREADY_CREATED_ACCOUNT_MESSAGE,
        LOGIN_WITH_EXISTING_DETAILS_MESSAGE,
        IF_FORGOTTEN_PASSWORD_MESSAGE,
        IF_YOU_NEED_HELP_MESSAGE
      );
      break;
    case RESPONSE_CODES.SignUp_RegistrationError_Account_Type.toLowerCase():
      title = ACCOUNT_ALREADY_EXISTS_TITLE;
      messages.push(
        DETAILS_ALREADY_EXIST_MESSAGE,
        LOGIN_WITH_EXISTING_DETAILS_MESSAGE,
        CORPORATE_ADMINISTRATOR_ADVICE_MESSAGE
      );
      break;
    case RESPONSE_CODES.SignUp_RegistrationError.toLowerCase():
      messages.push(sorryUnableTo("complete your registration"), supportCodeMessage(supportCode));
      break;
    default:
      messages.push(sorryUnableTo("complete your registration"), TECH_GLITCH_MESSAGE, TRY_AGAIN_LATER_MESSAGE);
  }
  return [messages, title];
}

export function createRegisterSuccessMessages(emailDestination: string): string[] {
  return [
    "Thanks for registering!",
    "You will shortly receive an email containing information to confirm your registration.",
    "The email will be sent to: " + emailDestination
  ];
}
